export enum DeliveryEnum {
  OFFICE = '10',
  DELIVERY = '20',
  INTERNATIONAL = '11',
}
